// Blacktie legacy apparel configuration; native SDK runtime stays on the vendor CDN.
import { a as e, j as t, P as s, S as a } from "https://cdnjs.getrealift.com/latest/render-329acc26.js";
import { R as o } from "https://cdnjs.getrealift.com/latest/RealsizeRecommendations-30a42f55.js";
import "https://cdnjs.getrealift.com/latest/backend-7f2a2f5d.js";

const r = ["slim", "relaxed", "baggy"];
const n = ["Fitted", "True to Size", "Loose"];

function mountReaLift(i) {
  if (!i?.parentElement) return;
  const returnURL = new URL(window.location.href);

  returnURL.searchParams.delete("realift_session");

  const activeTheme = window.Shopify?.theme;

  if (
    activeTheme?.role === "unpublished" &&
    activeTheme.id &&
    !returnURL.hostname.endsWith(".shopifypreview.com")
  ) {
    returnURL.searchParams.set(
      "preview_theme_id",
      String(activeTheme.id)
    );
  } else if (activeTheme?.role === "main") {
    returnURL.searchParams.delete("preview_theme_id");
  }

  i.dataset.productUrl = returnURL.href;

  const {
    product: c,
    variant: l,
    collectionsTitles: d,
    productUrl: m
  } = i?.dataset;

  ((
    i,
    {
      shop: c,
      product: l,
      variant: d,
      collectionsTitles: m,
      productUrl: p,
      data: u,
      realfitEndpoint: h,
      enabledMeasurements: x = [
        "chest",
        "upper_body",
        "waist",
        "sleeve",
        "hips",
        "inseam"
      ],
      customMeasurementLabels: f
    }
  ) => {
    const b = "realsize";
    const g = `https://blacktie.${b}.getrealift.com`;

    e(i, {
      app: b,
      addonElement: t.jsx(o, {}),

      theme: {
        mode: "dropdown",
        mobileMode: "dropdown",

        cssVars: {
          "app-default-background": "#E4EAF0",
          "card-default-background": "#FFFFFF"
        },

        components: {
          button: {
            className: "btn align-middle alt py-0 px-3"
          },
          switch: {
            className: "no-hover"
          }
        },

        elements: {
          mainButton: {
            component: ({ buttonOnClick: e, service: a }) =>
              t.jsxs("button", {
                type: "button",
                onClick: e,
                className:
                  "btn _flex space-x-2 mb-4 p-1 items-center text-sm bg-[#fff]",
                style: {
                  borderColor: "rgb(119,150,168)",
                  color: "rgb(119,150,168)",
                  borderRadius: "5px"
                },
                children: [
                  t.jsx(s, {}),
                  t.jsx("div", {
                    className: "leading-none",
                    children: a?.recommendations?.[1]
                      ? t.jsxs("span", {
                          className: "",
                          children: [
                            "Suggested Size: ",
                            a?.recommendations?.[1]
                          ]
                        })
                      : t.jsxs(t.Fragment, {
                          children: [
                            t.jsx("span", {
                              className: "",
                              style: {
                                color: "rgb(119,150,168)"
                              },
                              children: "Find Your Size"
                            }),
                            t.jsx("br", {}),
                            t.jsx("span", {
                              className: "text-xs ",
                              style: {
                                color: "rgb(119,150,168)"
                              },
                              children: "With a Quick Scan"
                            })
                          ]
                        })
                  }),
                  t.jsx("div", {
                    children: t.jsx("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      "stroke-width": "1.5",
                      stroke: "currentColor",
                      className: "h-6 w-6",
                      children: t.jsx("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M8.25 4.5l7.5 7.5-7.5 7.5"
                      })
                    })
                  })
                ]
              })
          },

          retryButton: {
            className: "py-2 bg-[#7796A8]"
          },

          tryAgainText: t.jsxs("div", {
            className: "_flex grid-cols-2 justify-between",
            children: [
              t.jsxs("div", {
                className: "text-left text-xs",
                children: [
                  t.jsx("span", {
                    children: "If your results seem inaccurate,"
                  }),
                  " ",
                  t.jsx("br", {}),
                  "try again with tighter fitting clothing."
                ]
              }),
              t.jsx("div", {
                className: "text-right text-xs",
                children: t.jsx("a", {
                  href: "https://blacktie.com/pages/use-your-phone-1",
                  className: "underline font-bold",
                  style: {
                    textDecoration: "underline",
                    textUnderlineOffset: "3px",
                    textDecorationThickness: "1px"
                  },
                  children: "Phone Size Finder Help & FAQs"
                })
              })
            ]
          })
        },

        pages: {
          demoImage: "ReaLift_GIF_Male.gif",

          [a.INITIALIZED]: {
            footer: t.jsx("div", {
              className: "text-xs",
              children: t.jsx("a", {
                href: "/pages/use-your-phone-1",
                className: "underline font-bold",
                style: {
                  textDecoration: "underline",
                  textUnderlineOffset: "3px",
                  textDecorationThickness: "1px"
                },
                children: "Phone Sizer Help & FAQs"
              })
            })
          }
        }
      },

      appPrefix: g,
      shop: c,
      product: l,
      variant: d,
      productUrl: p,
      data: u,
      realfitEndpoint: h,
      enabledMeasurements: x,
      customMeasurementLabels: f,

      getFitPayload: async () => {
  const options = [
    ...document.querySelectorAll('variant-picker .variant-option')
  ];

  const fitOption = options.find(option => {
    const heading = option.querySelector('legend, label') || option;
    const name = [...heading.childNodes]
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .map(node => node.textContent)
      .join('')
      .trim();

    return !!option.querySelector('select[name="options[Fit]"]') ||
      name.toLowerCase() === 'fit';
  });

  const select = fitOption?.querySelector('select');
  const radios = [
    ...(fitOption?.querySelectorAll('input[type="radio"]') || [])
  ];
  const singleValue = fitOption
    ?.querySelector('.variant-option__swatch-value')
    ?.textContent?.trim();

  const fit = [...new Set(
    select
      ? [...select.options].map(option => option.value.trim())
      : radios.length
        ? radios.map(input => input.value.trim())
        : singleValue ? [singleValue] : []
  )].filter(Boolean);

  const debugElement = document.getElementById('realift-debug-context');

  if (debugElement) {
    try {
      const debug = JSON.parse(debugElement.textContent || '{}');
      debug.fit = fit;
      delete debug.fit_options;
      debugElement.textContent = JSON.stringify(debug, null, 2);
    } catch (error) {
      console.warn('Could not update ReaLift debug JSON', error);
    }
  }

  return {
    html: Array.from(
      document.querySelectorAll('.option-selectors [data-option-name]')
    ).map(element => element.outerHTML).join(''),
    collections_titles: m,
    fit
  };
},

      updateCartAttributes(e) {
        const t = new URLSearchParams();

        if (e.measurements) {
          const s = Object.entries(e.measurements);

          if (s.length) {
            t.set(
              `attributes[ReaLift Measurements (Session: ${e.id})]`,
              s
                .map(([e, t]) => [e, t].join(": "))
                .join("\n")
            );
          }
        }

        if (e.recommendations) {
          t.set(
            `attributes[ReaLift Recommendations (Product: ${e.product}, Session: ${e.id})]`,
            r
              .map((t, s) =>
                [n[s], e.recommendations[t]].join(": ")
              )
              .join("\n")
          );
        }

        if (t.toString()) {
          fetch("/cart/update.js", {
            method: "POST",
            body: t
          });
        }
      }
    });
  })(i?.parentElement, {
    shop: "blacktie.com",
    product: c,
    variant: l,
    collectionsTitles: JSON.parse(d),
    productUrl: m,
    realfitEndpoint:
      "https://t21idd4jcj.execute-api.us-east-2.amazonaws.com"
  });
}

// Combined Listings replaces the product section without re-running module scripts.
// Mount once per new container, using that color product's own Liquid data.
const mountedReaLiftScripts = new WeakSet();
let pendingReaLiftMount = false;
function mountCurrentReaLift() {
  pendingReaLiftMount = false;
  const script = document.querySelector('#blacktie-realift-legacy #realiftScript');
  const root = script?.parentElement;
  if (!root || mountedReaLiftScripts.has(script)) return;
  mountedReaLiftScripts.add(script);
  mountReaLift(script);
  document.dispatchEvent(new Event("blacktie:realift-mounted"));
}
const reaLiftProductObserver = new MutationObserver(() => {
  if (pendingReaLiftMount) return;
  pendingReaLiftMount = true;
  requestAnimationFrame(mountCurrentReaLift);
});
reaLiftProductObserver.observe(document.documentElement, { childList: true, subtree: true });
mountCurrentReaLift();
